export default __webpack_public_path__ + "static/media/NH21_722_ELLE_GLORIA2154.d0d555bd.jpg";